import { useTrackArtistEdit, useTrackTitleEdit, useTrackPublishStatusEdit, useClientIdEdit, useUpdateTrack, } from "frontend/src/domain/tracks";
export var useTrackEdit = function (track) {
    var update = useUpdateTrack();
    var artist = ('artist' in track ? useTrackArtistEdit(track.artist) : useTrackArtistEdit(""));
    var title = useTrackTitleEdit(track.title);
    var published = useTrackPublishStatusEdit(track.is_approved);
    var client_id = useClientIdEdit(track.client_id);
    // const ownership = useTrackOwnershipEdit({
    //   type: track.type,
    //   clientId: track.type === "private" ? track.client.id : null,
    // });
    var run = function () {
        if (title.validate() && artist.validate()) {
            update.do({
                id: track.id,
                title: title.value,
                artist: artist.value,
                client: client_id.value,
                is_approved: published.value,
            });
        }
    };
    // React.useEffect(() => {
    //   if (ownership.type.value === "private") {
    //     businessTypes.set([]);
    //   } else {
    //     businessTypes.setFromBusinessTypes(
    //       track.type === "public" ? track.businessTypes : []
    //     );
    //   }
    // }, [ownership.type.value]);
    return {
        artist: artist,
        title: title,
        published: published,
        client_id: client_id,
        // clientId: ownership.clientId,
        update: {
            run: run,
            pending: update.isLoading,
        },
    };
};
